

/**
 * Load our base configurations.
 * This will be merged with envioronment specific settings.
 */
const BASE_CONFIG = require('./base.json');
const LOCAL_CONFIG = require('./env/local.json');
const DEV_CONFIG = require('./env/dev.json');
const STAGE_CONFIG = require('./env/stage.json');
const PROD_CONFIG = require('./env/prod.json');

/**
 * Class to detect and load the envioronment settings.
 */
const AppConfig = {
  /**
   * Detect the current envioronment base on the host url.
   *
   * @returns {string} - The environment code.
   */
  detectEnv() {
    const currentHost = window.location.hostname;
    let env;
    if (currentHost === 'skwad-dev.firebaseapp.com') {
      env = 'dev';
    } else if (currentHost === 'skwad-stage.firebaseapp.com') {
      env = 'stage';
    } else if (
      currentHost === 'app.standuppro.io'
      || currentHost === 'app.skwad.io'
      || currentHost === 'skwad-prod.firebaseap.com'
      || currentHost.endsWith('.vercel.app')
    ) {
      env = 'prod';
    } else {
      env = 'local';
    }

    return env;
  },

  /**
   * Inject local env variables, overriding static config
   *
   * @param {Object} currentConfig - The current config.
   * @returns {Object} - Key-value pair of overriden config.
   * @see `AppConfig.load()`
   */

  injectLocalEnv(currentConfig) {
    const overrideConfig = process.env;
    const newConfig = { ...currentConfig };

    Object.keys(overrideConfig).forEach((k) => {
      // convert VUE_APP_BAT_CAVE to bat_cave
      // https://cli.vuejs.org/guide/mode-and-env.html#environment-variables
      const key = k.slice(4).toLowerCase();

      if (key in currentConfig) {
        newConfig[key] = overrideConfig[k];
      }
    });

    return newConfig;
  },

  /**
   * Get the configuration of the specific envioronment.
   *
   * @param {string} env - The detected environment.
   * @returns {Object} - Key-value pair of settings.
   * @see `AppConfig.detectEnv()`
   */
  getConfig(env) {
    let config = {};

    if (env === 'local') {
      config = LOCAL_CONFIG;
    } else if (env === 'dev') {
      config = DEV_CONFIG;
    } else if (env === 'stage') {
      config = STAGE_CONFIG;
    } else if (env === 'prod') {
      config = PROD_CONFIG;
    }

    return { ...BASE_CONFIG, ...config };
  },

  /**
   * Load the envioronment configuration.
   *
   * @returns {Object} - The envioronment configuration.
   */
  load() { // eslint-disable-line class-methods-use-this
    const env = this.detectEnv();
    const baseConfig = this.getConfig(env);
    const config = this.injectLocalEnv(baseConfig);

    return { env, config };
  },

  install(Vue) {
    Vue.prototype.$env = this.load().env; // eslint-disable-line no-param-reassign
  },
};

export default AppConfig;
